export const formatItemUrl = (code, source) => {
  switch (source) {
    case 'AZ_US': {
      return `https://www.amazon.com/dp/${code}`;
    }
    case 'AZ_UK': {
      return `https://www.amazon.co.uk/dp/${code}`;
    }
    case 'AZ_CA': {
      return `https://www.amazon.ca/dp/${code}`;
    }
    case 'AZ_DE': {
      return `https://www.amazon.de/dp/${code}`;
    }
    case 'AZ_IT': {
      return `https://www.amazon.it/dp/${code}`;
    }
    case 'AZ_FR': {
      return `https://www.amazon.fr/dp/${code}`;
    }
    case 'AZ_ES': {
      return `https://www.amazon.es/dp/${code}`;
    }
    case 'WM': {
      return `https://www.walmart.com/ip/${code}`;
    }
    case 'EBAY_US': {
      return `https://www.ebay.com/itm/${code}`;
    }
    case 'ALI_CN':
    case 'ALI_US': {
      return `https://www.aliexpress.com/item/${code}.html`;
    }
    case 'CJ_US':
    case 'CJ_CN': {
      return `https://cjdropshipping.com/product/-p-${code}.html`;
    }
    default: {
      return '';
    }
  }
};

export const formatOfferUrl = (code, source) => {
  switch (source) {
    case 'AZ_US': {
      return `https://www.amazon.com/gp/offer-listing/${code}`;
    }
    case 'AZ_UK': {
      return `https://www.amazon.co.uk/gp/offer-listing/${code}`;
    }
    case 'AZ_CA': {
      return `https://www.amazon.ca/gp/offer-listing/${code}`;
    }
    case 'AZ_DE': {
      return `https://www.amazon.de/gp/offer-listing/${code}`;
    }
    case 'AZ_IT': {
      return `https://www.amazon.it/gp/offer-listing/${code}`;
    }
    case 'AZ_FR': {
      return `https://www.amazon.fr/gp/offer-listing/${code}`;
    }
    case 'AZ_ES': {
      return `https://www.amazon.es/gp/offer-listing/${code}`;
    }
    case 'WM': {
      return `https://www.walmart.com/ip/${code}`;
    }
    case 'ALI_CN':
    case 'ALI_US': {
      return `https://www.aliexpress.com/item/${code}.html`;
    }
    case 'CATALOG': {
      return `https://console.triplemars.com/catalog?opened-item-id=${code}`;
    }
    default: {
      return '';
    }
  }
};

export const formatOrderUrl = (transaction, item, source) => {
  switch (source) {
    case 'EBAY_US': {
      return `https://www.ebay.com/sh/ord/details?transid=${transaction}&itemid=${item}&source=Orders`;
    }
    default: {
      return '';
    }
  }
};
